import {axiosService} from "./axios.service";
import {endPoints} from "../configs/urls";

const supportService = {
    listTickets: async (orderId) => {
        try {
            const params = orderId ? {order: orderId} : {};
            const res = await axiosService.get(endPoints.support.tickets, {params});
            return res;
        } catch (error) {
            throw error;
        }
    },
    createTicket: async (ticketData) => {
        try {
            const {attachments, ...rest} = ticketData;
            let data;
            if (attachments && attachments.length > 0) {
                data = new FormData();
                Object.entries(rest).forEach(([k, v]) => {
                    if (v !== undefined && v !== null) {
                        data.append(k, v);
                    }
                });
                attachments.forEach((file) => data.append('attachments', file));
            } else {
                data = Object.fromEntries(
                    Object.entries(rest).filter(([, v]) => v !== undefined && v !== null)
                );
            }
            const res = await axiosService.post(endPoints.support.tickets, data);
            return res;
        } catch (error) {
            throw error;
        }
    },
    getTicket: async (id) => {
        try {
            const res = await axiosService.get(`${endPoints.support.tickets}${id}/`);
            return res;
        } catch (error) {
            throw error;
        }
    },
    listMessages: async (ticketId) => {
        try {
            const res = await axiosService.get(`${endPoints.support.tickets}${ticketId}/messages/`);
            return res;
        } catch (error) {
            throw error;
        }
    },
    postMessage: async (ticketId, {body, attachments}) => {
        try {
            let data;
            if (attachments && attachments.length > 0) {
                data = new FormData();
                data.append('body', body);
                attachments.forEach((file) => data.append('attachments', file));
            } else {
                data = {body};
            }
            const res = await axiosService.post(`${endPoints.support.tickets}${ticketId}/messages/`, data);
            return res;
        } catch (error) {
            throw error;
        }
    },
    markRead: async (ticketId) => {
        try {
            const res = await axiosService.post(`${endPoints.support.tickets}${ticketId}/read/`);
            return res;
        } catch (error) {
            throw error;
        }
    },
};

export {supportService};
